import React, { useState, useEffect } from 'react';
import CRUDList from '../Common/CRUDList';
import { timezones } from '../../services/api';

function TimezonesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({ tz_code: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      setLoading(true);
      const response = await timezones.getAll();
      setItems(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setFormData({ tz_code: '' });
    setEditingId(null);
    setShowForm(true);
  };

  const handleEdit = (item) => {
    setFormData({ tz_code: item.tz_code });
    setEditingId(item.tz_id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this timezone?')) return;
    try {
      await timezones.delete(id);
      loadItems();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete timezone');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (editingId) {
        await timezones.update(editingId, formData);
      } else {
        await timezones.create(formData);
      }
      setShowForm(false);
      loadItems();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save timezone');
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setError('');
  };

  if (loading) {
    return (
      <div>
        <div className="page-header">
          <h2>Timezones</h2>
        </div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h2>Timezones</h2>
        <button className="btn btn-primary" onClick={handleCreate}>Add Timezone</button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {showForm && (
        <div className="form-card" style={{ marginBottom: '16px' }}>
          <h3>{editingId ? 'Edit Timezone' : 'Add Timezone'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Timezone Code*</label>
              <input
                type="text"
                value={formData.tz_code}
                onChange={(e) => setFormData({ ...formData, tz_code: e.target.value })}
                placeholder="e.g., Europe/Moscow, America/New_York"
                required
              />
              <small style={{ color: '#7f8c8d', marginTop: '4px', display: 'block' }}>
                Use standard IANA timezone identifiers (e.g., Europe/Moscow, America/New_York, Asia/Tokyo)
              </small>
            </div>

            <div className="button-group">
              <button type="submit" className="btn btn-primary">
                {editingId ? 'Update' : 'Create'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Timezone Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.tz_id}>
                <td>{item.tz_id}</td>
                <td>{item.tz_code}</td>
                <td>
                  <div className="actions">
                    <button className="btn btn-primary" onClick={() => handleEdit(item)}>Edit</button>
                    <button className="btn btn-danger" onClick={() => handleDelete(item.tz_id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TimezonesList;
